import React from 'react';
import TableCell from '@mui/material/TableCell';
import { arrayOf, func, number, shape } from 'prop-types';

/**
 * Renders MUI TableCell.
 * Groups items in rowSpan based on compareFn.
 * @returns {React.FC}
 */

const SpanRow = props => {
  const { items, index: currentIndex, compareFn = () => false, ...restProps } = props;

  if (currentIndex > 0 && compareFn(items[currentIndex - 1], items[currentIndex])) {
    return null;
  }

  let i = currentIndex + 1;
  while (i < items.length && compareFn(items[currentIndex], items[i])) {
    i += 1;
  }

  const rowSpan = i - currentIndex;

  return (
    <TableCell {...restProps} rowSpan={rowSpan} />
  );
};

SpanRow.propTypes = {
  items: arrayOf(shape({})).isRequired,
  index: number.isRequired,
  compareFn: func.isRequired
};

export default SpanRow;
